export const API_URL = '/api';
export const TASK_FUNDING_SOURCE_VALUES_YEAR_START = 2015;
export const TASK_FUNDING_SOURCE_VALUES_N_YEARS = 50;
